import type { CredentialPage } from '@rtkwlf/rendall';
import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const useDeleteCredentialedScan = (
  scannerId: string,
  options?: UseMutationOptions<
    void,
    unknown,
    number,
    {
      dataSnapshot?: CredentialPage;
    }
  >,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useMutation({
    mutationFn: (credentialId) =>
      api.deleteIvaCredentialScan({
        credentialId,
        organizationId: selectedOrganization.id,
        scannerId,
      }),
    ...options,
  });
};
